import { Component, HostListener } from '@angular/core';
import { ResponsiveService } from './core/services/responsive.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(private responsiveService: ResponsiveService) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.responsiveService.setScreenWidth(window.innerWidth);
  }
}
